import { unwrap } from '@sohanemon/utils';
import { WINDOW_CONFIGS } from '@/lib/config/windows';
import { useWindowStore } from '@/lib/store/window-manager';
import { Window } from './window';

export function WindowRenderer({
	maximizedMode = 'dock',
}: { maximizedMode?: 'cover' | 'dock' } = {}) {
	const windows = useWindowStore((s) => s.windows);

	return (
		<>
			{windows
				.filter((w) => w.status !== 'closed')
				.map((win) => {
					const cfg = WINDOW_CONFIGS.find((c) => c.id === win.id);
					if (!cfg) return null;
					return (
						<Window
							key={win.id}
							id={win.id}
							contentClassName={cfg.contentClassName}
							initialPosition={cfg.initialPosition}
							maximizedMode={maximizedMode}
						>
							{unwrap(cfg.element)}
						</Window>
					);
				})}
		</>
	);
}
